import React from 'react';

import { PageAnalyticsPageLoader } from '@confluence/confluence-analytics/entry-points/PageAnalyticsPage.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';

export const PageAnalyticsRoute: {
	({ params: { contentId } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { spaceKey, contentId, tab } }: RouteMatch): {
		Screen: {
			// screenEvent will be handled in the page components
			pageState: {
				spaceKey: string;
				contentId: string;
				tab: string;
			};
		};
		MainLayout: {
			spaceKey: string;
			navView: string;
		};
	};
} = ({ params: { contentId } }: RouteMatch): React.JSX.Element => {
	return <PageAnalyticsPageLoader contentId={contentId} />;
};

PageAnalyticsRoute.NAVIGATION_PARAMS = ({
	params: { spaceKey, contentId, tab },
}: RouteMatch): {
	Screen: {
		// screenEvent will be handled in the page components
		pageState: {
			spaceKey: string;
			contentId: string;
			tab: string;
		};
	};
	MainLayout: {
		spaceKey: string;
		navView: string;
	};
} => ({
	Screen: {
		// screenEvent will be handled in the page components
		pageState: {
			spaceKey,
			contentId,
			tab,
		},
	},
	MainLayout: {
		spaceKey,
		navView: CONTAINER_HOME_ID,
	},
});
